import React, { useEffect, useState } from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { AnimatedLine } from "@mui/x-charts/LineChart";
import { useDispatch } from "react-redux";
import { fetchDashboardDataPerMonth } from "../../../actions/user";
import { useSelector } from "react-redux";

const LineChartComponent = () => {
  const dispatch = useDispatch();

  const [chartData, setChartData] = useState({
    seriesData: [],
    xLabels2: [],
  });

  const { dashboardDataPerMonth } = useSelector((state) => state.userReducer);

  useEffect(() => {
    dispatch(fetchDashboardDataPerMonth());
  }, [dispatch]);

  useEffect(() => {
    const countryDataMap = new Map();
    const xLabels2 = [];

    dashboardDataPerMonth
      .slice()
      .reverse()
      .forEach((monthData) => {
        const dateObj = new Date(monthData.date);
        const formattedDate = new Intl.DateTimeFormat("EN", {
          month: "short",
          year: "numeric",
        }).format(dateObj);
        xLabels2.push(formattedDate);

        monthData.items.forEach((item) => {
          if (!countryDataMap.has(item.countryName)) {
            countryDataMap.set(item.countryName, []);
          }
          countryDataMap.get(item.countryName).push(item.count);
        });
      });

    const seriesData = Array.from(countryDataMap, ([countryName, data]) => ({
      data,
      label: countryName,
    }));

    setChartData({
      seriesData,
      xLabels2,
    });
  }, [dashboardDataPerMonth]);

  return (
    <LineChart
      animatedLine={AnimatedLine}
      height={400}
      series={chartData.seriesData}
      xAxis={[{ scaleType: "point", data: chartData.xLabels2 }]}
    />
  );
};

export default LineChartComponent;
